export { default as NewPasswordWithCriteria } from './NewPasswordWithCriteria';
export type { NewPasswordWithCriteriaProps } from './NewPasswordWithCriteria';
